// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@ces/App/Components/Notify";
import dataTableStyles from "@ces/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentQuotesStyles } from "@ces/Overrides/Widgets/Common/RecentQuotes";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

recentQuotesStyles.noQuotesGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentQuotesStyles.noQuotesText = {
    ...mergeWithCss(getNotifyStyle("info", true), {
        css: css`
            margin: 0;
        `,
    }),
};

recentQuotesStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

recentQuotesStyles.dataTableHead = {
    css: css`
        line-height: 13px;
    `,
};
recentQuotesStyles.dataTableHeaders = {
    tight: true,
};

recentQuotesStyles.shipTodataTableHeaders = {
    tight: true,
    css: css`
        min-width: 240px;
    `,
};

recentQuotesStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            justify-content: space-between;
            align-items: flex-end;
            flex-wrap: wrap;
            margin-bottom: 16px;

            ${xScreen("lte", "md")} {
                flex-direction: row;
                align-items: baseline;
            }

            ${xScreen("lt", "sm")} {
                flex-direction: column;
            }
        `,
    },
    title: {
        variant: "h3",
        color: "text.main",
    },
    linkWithArrow: {
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            css: css`
                letter-spacing: 0;
                line-height: 15px;
            `,
        },
        icon: {
            iconProps: {
                src: LinkArrowRight,
                color: "text.link",
                css: css`
                    height: 13px;
                    width: 11px;
                `,
            },
            position: "right",
        },
    },
    link: {
        typographyProps: {
            size: 12,
            css: css`
                line-height: 15px;
            `,
        },
    },
};

recentQuotesStyles.quoteSummaryCard = {
    dataTableRow: {
        css: css`
            td[class^="DataTableCellBase"] {
                line-height: 22px;
            }
        `,
    },
    shipToCells: {
        css: css`
            ${ellipsis(1)}
        `,
    },
};

recentQuotesStyles.statusWrapper = {
    css: css`
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 14px;
        font-weight: ${fontConfig.weight.bold};
    `,
};

recentQuotesStyles.statusTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            height: 14px;
        `,
    },
};
